import { render, staticRenderFns } from "./editEndCustomerDialog.vue?vue&type=template&id=b19dd76e&lang=pug"
import script from "./editEndCustomerDialog.vue?vue&type=script&lang=js"
export * from "./editEndCustomerDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports